import http from "./http";

// 获取设备
export function get_asset_api() {
  return new Promise((resolve, reject) => {
    http.get("/asset").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取维修设备
export function get_repair_api(id) {
  return new Promise((resolve, reject) => {
    http.get("/asset/repair?asset_id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 获取类型
export function get_asset_type_api() {
  return new Promise((resolve, reject) => {
    http.get("/asset/count").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

// 校区筛选设备
export function get_assetFilter_api(id) {
  return new Promise((resolve, reject) => {
    http.get("/asset/school?school_id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//新增设备
export function post_asset_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/asset", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//报修
export function post_repair_api(data) {
  return new Promise((resolve, reject) => {
    http.post("/asset/repair", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//修改报修价格
export function put_repair_api(id, data) {
  return new Promise((resolve, reject) => {
    http.put("/asset/repair?id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//报修记录删除
export function delete_repair_api(id) {
  return new Promise((resolve, reject) => {
    http.delete("/asset/repair?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//修改
export function put_asset_api(id, data) {
  return new Promise((resolve, reject) => {
    http.put("/asset?id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//删除
export function delete_asset_api(id) {
  return new Promise((resolve, reject) => {
    http.delete("/asset?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//分配
export function put_assetSchool_api(asset_id, school_id) {
  return new Promise((resolve, reject) => {
    http
      .put("/asset/school?asset_id=" + asset_id + "&school_id=" + school_id)
      .then(
        (response) => {
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

//管理人
export function put_assetUser_api(asset_id, user_id) {
  return new Promise((resolve, reject) => {
    http.put("/asset/user?asset_id=" + asset_id + "&user_id=" + user_id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
